var lpItemScript = document.currentScript;

$(document).ready(function () {
  var localeRoot = (lpItemScript && lpItemScript.dataset.localeRoot || "/").replace(/\/$/, "");
  var modelSelectPrompt = lpItemScript && lpItemScript.dataset.selectPrompt || "Please select";

  /*********************************/
  /*         タブスライダー        */
  /*********************************/
  /*
  $('.js-lp-item-nav').slick({
    infinite: false,
    variableWidth: true,
    centerMode: false,
    centerPadding: '0',
    lazyLoad: 'progressive',
    arrows: false,
    swipeToSlide: true,
    touchMove: true,
  });
  */

  /*********************************/
  /*          タブ切り替え         */
  /*********************************/
  var initialTab = $(".js-tab.is-current");
  if (!initialTab.length) {
    initialTab = $(".js-tab").first().addClass("is-current");
    initialTab.parent().addClass("is-current");
  }

  var target = initialTab.data("target");
  $(".js-content").hide();
  $("#" + target).addClass("is-current").show();

  $(".js-tab").on("click", function () {
    $(".js-tab").removeClass("is-current");
    $(".js-tab").parent().removeClass("is-current");

    $(this).addClass("is-current");
    $(this).parent().addClass("is-current");

    $(".js-content").removeClass("is-current").hide();
    var target = $(this).data("target");
    $("#" + target).addClass("is-current").fadeIn(300);

    loadContentForTab(`#${target}`);
  });

  $(".tab-buttons__next").on("click", function () {
    $(".js-tab.is-current").next(".js-tab").trigger("click");
  });

  $(".tab-buttons__prev").on("click", function () {
    $(".js-tab.is-current").prev(".js-tab").trigger("click");
  });

  /************************************/
  /*   タイトル用 共通ユーティリティ   */
  /************************************/
  function normalizeTitleForDisplay(str) {
    return (str ?? "")
      .replace(/\\+([^\\]+)\\+/g, '"$1"')
      .replace(/""+/g, '"');
  }

  function stripPrefix(str, prefix) {
    str = (str ?? "").trim();
    return str.startsWith(prefix) ? str.slice(prefix.length).trim() : str;
  }

  function mergeRemoveOverlap(a, b, separator = " ") {
    a = (a ?? "").trim();
    b = (b ?? "").trim();
    if (!a) return b;
    if (!b) return a;

    if (b.startsWith(a)) return b;
    if (a.startsWith(b)) return a;

    for (let i = Math.min(a.length, b.length); i > 0; i--) {
      if (a.slice(-i) === b.slice(0, i)) {
        return a + b.slice(i);
      }
    }
    return a + separator + b;
  }

  // full：col_ + productname_（既存互換）
  // half：col_ のアンダーバー以降だけ（= col_ を除いた残り）
  // none：現状通り（display:block を当てない）
  function applyTitleAndPrice($content, $list) {
    const titleMode = String($content.data("show-title") || "full").toLowerCase(); // full|half|none
    const showPrice = String($content.data("show-price")).toLowerCase() === "true";

    $list.find(".product-item").each(function () {
      const $item = $(this);
      const $title = $item.find(".product-slideShow-title");
      if (!$title.length) return;

      const tagsAttr = $item.attr("data-product-tags");
      let tags = [];

      if (tagsAttr) {
        try {
          tags = JSON.parse(tagsAttr.replace(/&quot;/g, '"')) || [];
        } catch (e) {
          console.error("tag parse error:", e);
        }
      }

      // none：何もしない（= display:block を当てない前提）
      if (titleMode === "none") return;

      // col_ / productname_ 抽出
      const colTag = tags.find((t) => t.startsWith("col_"));
      const productTag = tags.find((t) => t.startsWith("productname_"));

      const colText = colTag ? stripPrefix(colTag, "col_") : "";
      const productTitle = $item.data("product-item-title") || "";
      const productText = window.caseplayDisplayTitle(productTitle, productTag);

      // half：省略表示 → col_ のアンダーバー以降だけ
      if (titleMode === "half") {
        if (colText) {
          $title.text(normalizeTitleForDisplay(colText));
          return;
        }
        // col_ が無い場合はフォールバック（旧のハイフン以降）
        const raw = $title.text();
        const m = raw.match(/.*?-([\s\S]*)/);
        const base = m && m[1] ? m[1].trim() : raw.trim();
        $title.text(normalizeTitleForDisplay(base));
        return;
      }

      // full：全表示 → col_ + productname_（既存互換）
      // （タグが取れない場合は旧フォールバック）
      let base = "";
      if (colText || productText) {
        base = mergeRemoveOverlap(colText, productText, " ");
      } else {
        const raw = $title.text();
        const m = raw.match(/.*?-([\s\S]*)/);
        base = m && m[1] ? m[1].trim() : raw.trim();
      }

      $title.text(normalizeTitleForDisplay(base));
    });

    // 表示制御：none 以外は見せる
    if (titleMode !== "none") {
      $list.find(".product-slideShow-title").css({
        display: "block",
        textAlign: "center",
        color: "#333",
      });
    }

    if (showPrice) {
      $list.find(".product-slideShow-price").css({ display: "block" });
    }
  }

  /************************************/
  /*   コンテンツ読み込み             */
  /************************************/
  async function loadContentForTab(targetContent) {
    const $content = $(targetContent);
    const $list = $content.find(".lp-item__list");

    // 旧構造：.js-content 側に data-collection-url がある想定
    const collectionUrl = $content.data("collection-url");
    if (!collectionUrl || !$list.length) return;

    try {
      const res = await fetch(collectionUrl);
      const html = await res.text();
      const doc = new DOMParser().parseFromString(html, "text/html");

      const grid =
        doc.querySelector(".collection.grid") ||
        doc.querySelector("#product-grid") ||
        doc.querySelector('[data-id="product-grid"]') ||
        doc.querySelector(".collection__products");

      if (!grid) return;

      const items = Array.from(grid.querySelectorAll(".product-item"));
      const empty = grid.querySelector(".collection-empty");

      let out = "";
      if (items.length) out = items.map((i) => i.outerHTML).join("");
      else if (empty) out = empty.outerHTML;
      else out = grid.innerHTML;

      $list.html(out);

      // タイトル/価格（full/half/none）
      applyTitleAndPrice($content, $list);

      // freeword
      $list.find(".product-item").each(function () {
        const $item = $(this);
        const tagsAttr = $item.attr("data-product-tags");
        if (!tagsAttr) return;

        try {
          const tags = JSON.parse(tagsAttr.replace(/&quot;/g, '"')) || [];
          const fw = tags.filter((t) => t.startsWith("freeword_"));
          if (!fw.length) return;

          const $wrap = $('<div class="product-slideShow-freeword-list"></div>');
          fw.forEach((t) => {
            $wrap.append(
              $('<span class="product-slideShow-freeword-tag"></span>').text(
                t.replace("freeword_", "")
              )
            );
          });
          $item.append($wrap);
        } catch (e) {
          console.error("freeword error:", e);
        }
      });
    } catch (e) {
      console.error(e);
    }
  }

  /************************************/
  /*   機種セレクト                   */
  /************************************/
  if (!$(".manufacturer_selector").length) return;

  const currentTag = "{{ current_tags }}";
  const modelGroups = window.fox.settings.model_groups_checkbox;

  if (!$(".model-select").length) {
    $(".manufacturer_selector").append(
      $('<select class="model-select"></select>').append(
        $('<option value="" disabled selected></option>').text(modelSelectPrompt)
      )
    );
  }

  // option追加（旧互換：add_checkだけ維持）
  modelGroups.forEach((g) => {
    (g.code_sort || []).forEach((code) => {
      $(".model-select").append(
        `<option value="mo_${code}">
          ${window.fox.settings.model[code]} ${/AP/.test(code) ? "(iPhone)" : "(Android)"}
        </option>`
      );
      if (currentTag.match(`mo_${code}`)) $(".model-select").addClass("add_check");
    });
  });

  $(".model-select").on("change", async function () {
    const handle = $(".js-tab.is-current").data("handle");
    const val = $(this).val();

    const isAllCase = [
      "series-iphone",
      "series-android",
      "xperia-series",
      "galaxy-series",
      "pixel-series",
      "xiaomi-series",
      "motorola-series",
    ].includes(handle);

    const url = isAllCase
      ? `${localeRoot}/collections/all-case/${val}`
      : `${localeRoot}/collections/${handle}/${val}`;

    try {
      const res = await fetch(url);
      const html = await res.text();
      const doc = new DOMParser().parseFromString(html, "text/html");

      const grid =
        doc.querySelector(".collection.grid") ||
        doc.querySelector("#product-grid") ||
        doc.querySelector('[data-id="product-grid"]') ||
        doc.querySelector(".collection__products");

      if (!grid) return;

      const items = Array.from(grid.querySelectorAll(".product-item"));
      const empty = grid.querySelector(".collection-empty");

      const $list = $(".js-content.is-current .lp-item__list");
      if (!$list.length) return;

      const out =
        items.length ? items.map((i) => i.outerHTML).join("") : empty ? empty.outerHTML : grid.innerHTML;

      $list.html(out);

      // 差し替え後にも、同じ表示ルールを適用
      applyTitleAndPrice($(".js-content.is-current"), $list);

      // freeword（差し替え後も付与）
      $list.find(".product-item").each(function () {
        const $item = $(this);
        const tagsAttr = $item.attr("data-product-tags");
        if (!tagsAttr) return;

        try {
          const tags = JSON.parse(tagsAttr.replace(/&quot;/g, '"')) || [];
          const fw = tags.filter((t) => t.startsWith("freeword_"));
          if (!fw.length) return;

          const $wrap = $('<div class="product-slideShow-freeword-list"></div>');
          fw.forEach((t) => {
            $wrap.append(
              $('<span class="product-slideShow-freeword-tag"></span>').text(
                t.replace("freeword_", "")
              )
            );
          });
          $item.append($wrap);
        } catch (e) {
          console.error("freeword error:", e);
        }
      });
    } catch (e) {
      console.error(e);
    }
  });

  // 初回
  loadContentForTab(`#${$(".js-tab.is-current").data("target")}`);
});

// fox_3v.jsを改造した旧コード
// (function() {
//   $(document).ready(function() {
//     var $option, l, len2, len3, m, model_code, model_group, ref2, ref3, selected_option;
//     /* コレクションページサイドバーの機種選択初期処理 */
//     if ($('.manufacturer_selector').length) {
//       //現在の機種取得
//       selected_option = $('.collection-sidebar .model_selector .active').val();
//       ref2 = window.fox.settings.model_groups_checkbox;

//       /* --- 複数使用するものは関数に --- */
//       //小カテゴリ「iphone」「android」リンクの配列
//       var iPhone_model_code = [];
//       var android_model_code = [];

//       //OSと機種のコレクション
//       var checkbox_collection = 'series-iphone ,series-android , xperia-series, galaxy-series, pixel-series, xiaomi-series, motorola-series';

//       //iphone機種名リンク
//       var iphonemodel_link = function() {
//         if (model_code.match(/AP/)) {
//           // iPhoneの機種名を<option>タグとして作成
//           $option = '<option value="mo_' + model_code + '">' + window.fox.settings.model[model_code] + ' (iPhone)</option>';

//           // すでに<select>タグがある場合、その中に<option>を追加する
//           if ($('.model-select').length === 0) {
//             // <select>タグがまだ無ければ、1つ目の<select>を追加
//             $('.manufacturer_selector').append('<select class="model-select"></select>');
//           }

//           // 追加した<select>に<option>を追加
//           $('.model-select').append($option);

//           iPhone_model_code.push(model_code);

//           // 変更時にリンクに飛ばす
//           (function(m) {
//             $('.model-select').change(function() {
//                 // 現在選択されているタブ(.is-current)からdata-handle属性を取得
//                 var currentHandle = $('.js-tab.is-current').data('handle');
//                 var selectedValue = $(this).val();
//                 // handleがcheckbox_collectionに含まれているかをチェック
//                 if (checkbox_collection.includes(currentHandle)) {
//                   location.href = '/collections/all-case/' + selectedValue;
//                 } else {
//                   location.href = '/collections/' + currentHandle + '/' + selectedValue;
//                 }
//             });
//             // 初期状態で選択されている場合はクラスを付ける
//             if (current_tag.match('mo_' + model_code)) {
//               $('.model-select').addClass("add_check");
//             }
//           })(m);
//         }
//       };

//       //android機種名リンク
//       var androidmodel_link = function() {
//         if (!model_code.match(/AP/)) {
//           // Androidの機種名を<option>タグとして作成
//           $option = '<option value="mo_' + model_code + '">' + window.fox.settings.model[model_code] + ' (Android)</option>';

//           // 追加した<select>に<option>を追加
//           $('.model-select').append($option);

//           android_model_code.push(model_code);

//           // 変更時にリンクに飛ばす
//           (function(m) {
//             $('.model-select').change(function() {
//               var currentHandle = $('.js-tab.is-current').data('handle');
//               var selectedValue = $(this).val();
//               // handleがcheckbox_collectionに含まれているかをチェック
//               if (checkbox_collection.includes(currentHandle)) {
//                 location.href = '/collections/all-case/' + selectedValue;
//               } else {
//                 location.href = '/collections/' + currentHandle + '/' + selectedValue;
//               }
//             });
//             // 初期状態で選択されている場合はクラスを付ける
//             if (current_tag.match('mo_' + model_code)) {
//               $('.model-select').addClass("add_check");
//             }
//           })(m);
//         }
//       };

//       /* --- 大カテゴリ作成 --- */
//       for (l = 0, len2 = ref2.length; l < len2; l++) {
//         model_group = ref2[l];
//         /* --- 小カテゴリ作成 --- */
//         ref3 = model_group.code_sort;
//         for (m = 0, len3 = ref3.length; m < len3; m++) {
//           model_code = ref3[m];
//             iphonemodel_link();
//             androidmodel_link();
//         }
//       }

//       if ($('.model-select').hasClass('add_check')) {
//         $('.model-select').show();
//       }
//     }

//   });
// }).call(this);

// 一旦完璧
// (function () {
//   $(document).ready(function () {
//     if (!$('.manufacturer_selector').length) return;

//     var currentTag = '{{current_tags}}';
//     var modelGroups = window.fox.settings.model_groups_checkbox;

//     // 共通の<select>を生成
//     if (!$('.model-select').length) {
//       $('.manufacturer_selector').append('<select class="model-select"></select>');

//       // 最初の<option>を追加
//       $('.model-select').append('<option value="" disabled selected>絞り込み</option>');
//     }

//     // 機種を選択肢に追加する関数
//     function addModelOption(modelCode, label) {
//       var $option = `<option value="mo_${modelCode}">${label}</option>`;
//       $('.model-select').append($option);

//       // 初期選択状態を確認
//       if (currentTag.match(`mo_${modelCode}`)) {
//         $('.model-select').addClass('add_check');
//       }
//     }

//     // 機種データを処理して選択肢を追加
//     modelGroups.forEach(group => {
//       group.code_sort.forEach(modelCode => {
//         if (modelCode.match(/AP/)) {
//           addModelOption(modelCode, `${window.fox.settings.model[modelCode]} (iPhone)`);
//         } else {
//           addModelOption(modelCode, `${window.fox.settings.model[modelCode]} (Android)`);
//         }
//       });
//     });

//     // OSと機種のコレクション
//     var checkboxCollection = 'series-iphone ,series-android ,xperia-series, galaxy-series, pixel-series, xiaomi-series, motorola-series';

//     // 選択時の処理
//     $('.model-select').change(async function () {
//       const currentHandle = $('.js-tab.is-current').data('handle');
//       const selectedValue = $(this).val();

//       // currentHandleがcheckboxCollectionに含まれているかをチェック
//       let url;
//       if (heckboxCollection.includes(currentHandle)) {
//         url = `/collections/all-case/${selectedValue}`;
//       } else {
//         url = `c/collections/${currentHandle}/${selectedValue}`;
//       }

//       console.log('Fetching URL:', url);

//       try {
//         const response = await fetch(url);
//         if (!response.ok) {
//           console.error('Failed to fetch the HTML:', response.statusText);
//           return;
//         }

//         const htmlText = await response.text();
//         const parser = new DOMParser();
//         const doc = parser.parseFromString(htmlText, 'text/html');
//         const newGridContent = doc.querySelector('.collection.grid');

//         if (!newGridContent) {
//           console.warn('.collection.grid not found in the fetched HTML.');
//           return;
//         }

//         const currentList = $('.js-content.is-current .lp-item__list');
//         if (currentList.length) {
//           // 最大40個の.product-itemを取得
//           const products = Array.from(newGridContent.querySelectorAll('.product-item')).slice(0, 40);
//           const newHtml = products.map(product => product.outerHTML).join('');
//           currentList.html(newHtml);
//           console.log('Content replaced successfully.');
//         } else {
//           console.warn('.lp-item__list not found in the current tab.');
//         }
//       } catch (error) {
//         console.error('Error fetching and parsing HTML:', error);
//       }
//     });

//     // **ロード時にすべてのタブを処理してコンテンツを差し替える**
//     async function replaceAllLists() {
//       $('.lp-item__content').each(async function () {
//         const $content = $(this);
//         const collectionUrl = $content.data('collection-url'); // data-collection-url属性からURLを取得
//         const $list = $content.find('.lp-item__list');

//         console.log('Fetching URL (initial load):', collectionUrl);

//         try {
//           const response = await fetch(collectionUrl);
//           if (!response.ok) {
//             console.error('Failed to fetch the HTML:', response.statusText);
//             return;
//           }

//           const htmlText = await response.text();
//           const parser = new DOMParser();
//           const doc = parser.parseFromString(htmlText, 'text/html');
//           const newGridContent = doc.querySelector('.collection.grid');

//           if (!newGridContent) {
//             console.warn('.collection.grid not found in the fetched HTML.');
//             return;
//           }

//           // 最大40個の.product-itemを取得
//           const products = Array.from(newGridContent.querySelectorAll('.product-item')).slice(0, 40);
//           const newHtml = products.map(product => product.outerHTML).join('');
//           $list.html(newHtml);
//           console.log('Initial content replaced for:', collectionUrl);
//         } catch (error) {
//           console.error('Error fetching and parsing HTML:', error);
//         }
//       });
//     }

//     // 初期状態で全タブのリストを置き換え
//     replaceAllLists();

//     // 初期状態で表示設定
//     if ($('.model-select').hasClass('add_check')) {
//       $('.model-select').show();
//     }
//   });
// })();
